export const getDocumentKey = document => {
  const {appId, dataType, id, updated} = document
  const parts = []
  if (appId) parts.push(dataType)
  if (dataType) parts.push(dataType)
  if (id) parts.push(id)
  if (updated) parts.push(updated)
  return parts.join('_')
}
